module.exports = __webpack_public_path__ + "static/media/40_tn.4f539acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/40_tn.jpg
// module id = 528
// module chunks = 0